import React, { Component } from 'react';

/**
 * Child components that use Context props will always need a Provider. Once a Provider is wrapping the Child,
 * the Consumer within a Child component can be used to reference the passed props.
 */

export const conversationDetailsFromLocalStorage = () => JSON.parse(localStorage.getItem('conversationDetails'));
export const ConversationDetailsContext = React.createContext(conversationDetailsFromLocalStorage());

// Higher order Component: Chat APIs require conversationDetails object
export function withChatContext(WrappedComponent) {
    return class extends Component {
        render = () =>
            <ConversationDetailsContext.Provider value={conversationDetailsFromLocalStorage()}>
                <WrappedComponent {...this.props} />
            </ConversationDetailsContext.Provider>
    }
}